import { PLATFORM_PERMISSIONS } from './accessContract'

const AREA_LABELS: Record<string, string> = {
  'txh.platform.legal_control.policy': 'Legal control policies',
  'txh.platform.legal_control.subject': 'HUF appointment review',
  'txh.platform.notification': 'Notification review',
  'txh.platform.client.profile.review': 'Client profile review',
  'txh.platform.client.profile.verification': 'Client profile verification',
  'txh.platform.payment.failed_refund': 'Failed refund review',
  'txh.platform.tenant': 'Tenants',
  'txh.platform.user': 'User accounts',
  'txh.platform.audit': 'Platform audit history',
  'txh.platform.deletion': 'Deletion governance',
  'txh.monitoring.service': 'Service monitoring',
  'txh.monitoring.health': 'Health checks',
  'txh.monitoring.operation': 'Operation history',
  'txh.monitoring.restart': 'Service restarts',
  'txh.support.session': 'Temporary support access',
  'txh.support.data': 'Tenant data during support',
}
const ACTION_LABELS: Record<string, string> = {
  inspect: 'Inspect intake',
  submit: 'Submit for review',
  decide: 'Approve or reject',
  retire: 'Retire policy',
  review: 'Review',
  read: 'View',
  create: 'Create',
  update: 'Edit',
  archive: 'Archive',
  deactivate: 'Deactivate',
  'role.assign': 'Assign roles',
  'session.revoke': 'Revoke sessions',
  purge: 'Permanently delete',
  'hold.manage': 'Manage retention holds',
  execute: 'Run',
  approve: 'Approve',
  revoke: 'Revoke',
  write: 'Change data',
}

export function platformPermissionGroups(grants: readonly string[]) {
  const groups = new Map<string, { area: string; actions: { label: string; allowed: boolean }[] }>()
  for (const permission of PLATFORM_PERMISSIONS) {
    const area = Object.keys(AREA_LABELS).find(prefix => permission.startsWith(`${prefix}.`))
    if (!area) continue
    const group = groups.get(area) ?? { area: AREA_LABELS[area], actions: [] }
    const action = permission.slice(area.length + 1)
    group.actions.push({
      label: ACTION_LABELS[action] ?? action.replace(/\./g, ' '),
      allowed: grants.includes(permission),
    })
    groups.set(area, group)
  }
  return [...groups.values()]
}
